import { useEffect } from "react";

import { useAuthStore } from "@/store/authStore";
import { useBrandingStore } from "@/store/brandingStore";

/**
 * Fetch and apply the signed-in person's branding, again whenever that person
 * changes.
 *
 * Branding is resolved from the caller's own organization, so it belongs to
 * the identity, not to the page. Starting or stopping an impersonation swaps
 * the identity without remounting the layout that used to fetch it once on
 * mount: the admin kept the platform's colours while impersonating a branded
 * MSP's user, and would have kept that MSP's brand after stopping.
 */
export function useBrandingFollowsIdentity(): void {
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const fetchAndApply = useBrandingStore((s) => s.fetchAndApply);

  useEffect(() => {
    void fetchAndApply();
  }, [fetchAndApply, userId]);
}
